import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './CreateBtn.module.scss';

const CreateBtn: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<Link
			className={style.container}
			to={`/entertainment/games${hasAccess ? '/create' : ''}`}
			data-test="CreateBtn">
			<Button
				className={style.button}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#plus`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="addGameButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default CreateBtn;
